<template>
  <Navbar></Navbar>
  <Banner />
  <div class="content-wrapper">
    <div class="main-content">
      <ContactForm />
    </div>
    <FooterItem />
  </div>
</template>

<script>
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import ContactForm from "@/components/Contact/contactForm.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    Navbar,
    ContactForm,
    FooterItem,
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  methods: {
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "تواصل معنا - Planning Force | نحن هنا للمساعدة"
          : "Contact Us - Planning Force | We Are Here to Help";

      const description =
        this.currentLanguage === "ar"
          ? "اتصل بنا للحصول على أي استفسارات أو مساعدة تتعلق بخدماتنا. فريقنا جاهز لمساعدتك!"
          : "Get in touch with us for any inquiries or assistance regarding our services. Our team is ready to help!";

      const keywords =
        this.currentLanguage === "ar"
          ? "تواصل معنا, دعم, استفسارات, Planning Force, التعليم الإلكتروني"
          : "contact us, support, inquiries, Planning Force, e-learning";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/contact-og-image.jpg",
          }, // Replace with your contact page image URL
          { property: "og:url", content: "https://example.com/contact" }, // Replace with your contact page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/contact-twitter-image.jpg",
          }, // Replace with your contact page image URL
        ],
      });
    },
  },
  mounted() {
    this.updateHeadMeta();
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta();
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
};
</script>
